import type { DialMethod, IdleSensitivity, SprintMode } from '@deltasuite/supabase-client';
import { dialApiFetch, isDialApiConfigured } from './client';

export interface UserPreferences {
  user_id: string;
  daily_points_target: number;
  default_mode: SprintMode;
  preferred_dial_method: DialMethod;
  idle_nudge_sensitivity: IdleSensitivity;
  updated_at: string | null;
}

export const DEFAULT_PREFS: UserPreferences = {
  user_id: '',
  daily_points_target: 30,
  default_mode: 'user_list',
  preferred_dial_method: 'choose',
  idle_nudge_sensitivity: 'medium',
  updated_at: null,
};

export async function getPreferences(): Promise<UserPreferences> {
  if (!isDialApiConfigured) return DEFAULT_PREFS;
  return dialApiFetch<UserPreferences>('/v1/preferences/me');
}

export type PreferencesPatch = Partial<Omit<UserPreferences, 'user_id' | 'updated_at'>>;

export async function updatePreferences(patch: PreferencesPatch): Promise<UserPreferences> {
  return dialApiFetch<UserPreferences>('/v1/preferences/me', {
    method: 'PATCH',
    body: patch,
  });
}
